import Image from "next/legacy/image";
import React, { forwardRef, useContext, useEffect } from "react";
import MasterplanMainCard from "./MasterplanMainCard";
import { Mousewheel, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useRouter } from "next/router";
import { isMobileContext } from "../../contexts/isMobileContext";
import { useState } from "react";
import { BASE_URL } from "../../utils/FetchData";
import { MasterplanSubCard } from "./MasterplanSubCard";
import FadeIn from "../Animations/FadeIn";

// eslint-disable-next-line react/display-name
const Masterplan = forwardRef(
	({ masterplanData, projectPhases, projectSlug, masterPlanFacilities }, ref) => {
		const { isMobile } = useContext(isMobileContext);
		const [activePhase, setActivePhase] = useState(-1);
		const [showData, setShowData] = useState(false)
		const [facility, setFacility] = useState(false)
		// const [orderedPhases, setOrderedPhases] = useState()
		// useEffect(() => {
		// 	const order = []
		// 	projectPhases?.sort((a, b) => a.attributes.Order - b.attributes.Order).map(phase => {
		// 		order.push(phase)
		// 	})
		// 	setOrderedPhases(order)
		// }, [projectPhases])

		return (
			<div className="masterplan-section" ref={ref}>
				<>
					<div className="map">
						{masterplanData && (
							<Image
								src={isMobile ?
									BASE_URL + masterplanData?.Map_Mobile?.data?.attributes?.url :
									BASE_URL + masterplanData?.Map_Desktop?.data?.attributes?.url
								}
								alt={masterplanData?.Map_Desktop?.data?.attributes?.name}
								layout="fill"
								objectFit="cover"
							/>
						)}
						<div className="pins-container">
							{projectPhases?.map((phase, index) => (
								<div
									onClick={() => { setActivePhase(index), setShowData(true), setFacility(false) }}
									key={index}
									className={`pin-container ${activePhase == index && "active-pin"}`}
									style={{
										top: `${isMobile ?
											phase?.attributes?.Master_Plan_Card?.Y_Position_Mobile :
											phase?.attributes?.Master_Plan_Card?.Y_Position_Desktop

											}%`,
										left: `${isMobile ?
											phase?.attributes?.Master_Plan_Card?.X_Position_Mobile :
											phase?.attributes?.Master_Plan_Card?.X_Position_Desktop
											}%`,
									}}
								>
									<Image src="/project/pin.svg" layout="fill" alt="pin_icon" className="pin_icon" />
									{!isMobile &&
										<div className={`pin-info 
										${phase?.attributes?.Master_Plan_Card?.Y_Position_Desktop < 15 && 'postion'}
										`}>
											<span>{phase?.attributes?.Master_Plan_Card?.Phase_Name}</span>
										</div>
									}
								</div>
							))}
							{masterPlanFacilities?.map((facility, index) => (
								<div
									onClick={() => { setActivePhase(index + projectPhases.length), setShowData(true), setFacility(true) }}
									key={index}
									className={`pin-container facility-pin ${activePhase == index + projectPhases.length && "active-pin"}`}
									style={{
										top: `${isMobile ?
											facility?.Masterplan_Y_Postion_Mobile :
											facility?.Masterplan_Y_Postion_Desktop

											}%`,
										left: `${isMobile ?
											facility?.Masterplan_X_Postion_Mobile :
											facility?.Masterplan_X_Postion_Desktop
											}%`,
									}}
								>
									<Image src="/project/pin.svg" layout="fill" alt="pin_icon" className="pin_icon" />
									{!isMobile &&
										<div className={`pin-info 
										${facility?.Masterplan_Y_Postion_Desktop < 15 && 'postion'}
										`}>
											<span>{facility?.Facilitie_Name}</span>
										</div>
									}
								</div>
							))}
						</div>
					</div>
					<FadeIn customClass="header">
						<h2 className="light _eleX">{masterplanData?.Header}</h2>
					</FadeIn>
					{showData &&
						<MasterplanMainCard
							cardInfo={facility ? masterPlanFacilities[activePhase - projectPhases?.length] : projectPhases && projectPhases[activePhase]}
							projectSlug={projectSlug}
							showData={showData}
							setShowData={setShowData}
							setActivePhase={setActivePhase}
							facility={facility}
						/>
					}
				</>

			</div>
		);
	}
);
export default Masterplan;
